"use strict";

var createValidator = require('./validator');

var promisifiedValidator = require('./promisifiedValidator');

var _require = require('./consts'),
    dataFixerParamNames = _require.dataFixerParamNames,
    reservedParamNames = _require.reservedParamNames,
    pageModuleParamNames = _require.pageModuleParamNames;

module.exports = {
  createValidator: createValidator,
  promisifiedValidator: promisifiedValidator,
  dataFixerParamNames: dataFixerParamNames,
  reservedParamNames: reservedParamNames,
  pageModuleParamNames: pageModuleParamNames
};
//# sourceMappingURL=index.js.map